import React from 'react'
import { LOGO_IMG } from '../../../utills/image-constant';
import { useNavigate } from 'react-router-dom';
import { USERROUTES } from '../../../user/routes/url-constant';
import { ROUTES } from '../../routes/url-constant';

const FinalAssesmentsubmitionModal = ({ finalAssesmentModal, setFinalAssesmentModal, type }) => {
    let navigation = useNavigate();
    const handlenavigate = () => {
        setFinalAssesmentModal(false)
        if (type == "admin") {
            navigation(ROUTES.ONSITE);
        } else {
            navigation(USERROUTES.USERPROFILEINTRODUCTION)
        }
    }
    return (
        <div>
            <div>
                <div className={`modal fade ${finalAssesmentModal ? "show" : ""}`} style={{ display: finalAssesmentModal ? 'block' : 'none', background: finalAssesmentModal ? 'rgba(0,0,0,0.5)' : '' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content px-3 py-4">
                            <div className='d-flex justify-content-center align-items-center'>
                                <img src={LOGO_IMG} class="img-fluid logo_img" alt="..." />
                            </div>
                            <div className="modal-body border-0">
                                <h5 className="modal-title text-center" id="staticBackdropLabel">"your answers are now recorded. no change are possible, thank you for your time in this session""</h5>
                            </div>
                            <div className="modal-footer logout_footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={handlenavigate}>Ok</button>
                                {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => { handleaddAnswer() }}>Submit</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FinalAssesmentsubmitionModal;
